import LoginForm from './Components/Assets/LoginForm/LoginForm';

function App() {
  return (
    <div>
       <LoginForm />
    </div>
  );
}

export default App;
